<template>
  <UButton
    :to="{
      name: 'om-path',
      params: { path: 'kundeservice' },
    }"
  >
    <template #prepend>
      <slot name="prepend" />
    </template>
    <slot>
      Kundeservice
    </slot>
    <template #append>
      <slot name="append" />
    </template>
  </UButton>
</template>
